import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  1?: number;
  2?: number;
  3?: number;
}

// tipagem do que o hook retorna
export type IReponse = IResponseData;

async function getUsuariosPorStatus(): Promise<IReponse> {
  const response = await backend.get<IResponseData>(`/usuarios-por-status`);
  return response.data;
}

export function useUsuariosPorStatus() {
  return useQuery(['usuarios-por-status'], () => getUsuariosPorStatus(), {
    keepPreviousData: true,
    staleTime: 1000 * 30,
    cacheTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    retry: 1,
  });
}
